import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"position":"relative","height":"100%"} }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'tlLabels',
  props: {
  content: {
    type: Object,
    required: true,
  }
},
  setup(__props) {

const props = __props;

const styleHeader = computed(() => {
  return {
    position: 'absolute',
    left: props.content.x * 100 + "%"
  };
});

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_text_item, {
      txt: __props.content.dateStr,
      styles: "main-l",
      style: _normalizeStyle(styleHeader.value)
    }, null, 8, ["txt", "style"])
  ]))
}
}

})